import React from 'react';
import CoreComponent from './../core/CoreComponent';
import AbstractQuestionView from './AbstractQuestionView';

export default class AbstractQuestionPanel extends CoreComponent{
	constructor(props) {
	 super(props);
	 }

	 /*
	 * IMPORTANT: Callback function for the QuestionView to access.
	 * This can be overridden in Child classes for more specified usage.
	 * Maintain it empty here and override only in child classes.
	 */
	 callBackFunc(){

	 }

	 render() {		 
	   return(
        <div className="qcont">
             <AbstractQuestionView qno={this.props.qno} qdata={this.props.qdata} ga={this.props.ga} callbackParent={this.callBackFunc} accessId={this.props.accessId} classId={this.props.classId} />
        </div>
	   );
	  }
} 


// WEBPACK FOOTER //
// ./src/components/question/AbstractQuestionPanel.js